/**
 * In-tab bus from the app-wide inbox poll to the open inbox list.
 * Alerts fire in ProtectedLayout; the conversation list patches locally
 * so it does not need a full conversations+navigation fetch every few seconds.
 */

/**
 * @typedef {{
 *   messages?: Array<{ session_id?: string, message_content?: string, created_at?: number }>,
 *   handoffs?: Array<{ session_id?: string, created_at?: number }>,
 * }} InboxPollListPayload
 */

/** @type {Set<(payload: InboxPollListPayload) => void>} */
const listeners = new Set();

/** @param {(payload: InboxPollListPayload) => void} fn */
export function subscribeInboxPollListEvents(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** @param {InboxPollListPayload} payload */
export function notifyInboxPollListEvents(payload) {
  if (!payload) return;
  const messages = Array.isArray(payload.messages) ? payload.messages : [];
  const handoffs = Array.isArray(payload.handoffs) ? payload.handoffs : [];
  if (!messages.length && !handoffs.length) return;
  for (const fn of listeners) {
    try {
      fn({ messages, handoffs });
    } catch {
      /* subscriber errors must not break the poller */
    }
  }
}
